// Header count on the E-signatures page.
export function envelopeCountLabel(total, completed) {
  return `${total} ${total === 1 ? 'envelope' : 'envelopes'}, ${completed} completed`;
}
